// frontend/src/WorkWeekMonthView.js
import React from 'react'
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addWeeks,
  addDays,
  isSameMonth,
  isSameDay,
  format,
  startOfDay,
  isBefore,
} from 'date-fns'

const WEEKDAYS = ['Mon','Tue','Wed','Thu','Fri']

/**
 * Renders a month grid with Monday–Friday only.
 *
 * Props:
 *  - month: Date              // any date within the month to render
 *  - selected: Date           // the highlighted day
 *  - onSelect: (day: Date) => void
 */
export default function WorkWeekMonthView({ month, selected, onSelect }) {
  const today = startOfDay(new Date())

  // Monday before or on the 1st of the month
  const firstOfMonth = startOfMonth(month)
  const gridStart = startOfWeek(firstOfMonth, { weekStartsOn: 1 })

  // Sunday after or on the last day of the month
  const lastOfMonth = endOfMonth(month)
  const gridEnd = endOfWeek(lastOfMonth, { weekStartsOn: 1 })

  // Build week‐start dates
  const weeks = []
  let cursor = gridStart
  while (cursor <= gridEnd) {
    weeks.push(cursor)
    cursor = addWeeks(cursor, 1)
  }

  return (
    <div className="workweek-calendar">
      {/* Header row */}
      <div className="ww-header-row">
        {WEEKDAYS.map((wd) => (
          <div key={wd} className="ww-header-cell">{wd}</div>
        ))}
      </div>

      {/* Each week */}
      {weeks.map((weekStart) => (
        <div key={weekStart.toISOString()} className="ww-week-row">
          {WEEKDAYS.map((_, i) => {
            const day = addDays(weekStart, i)
            const inMonth = isSameMonth(day, month)
            const isSel   = isSameDay(day, selected)
            const isPast  = isBefore(startOfDay(day), today)

            let cls = 'ww-day-cell'
            if (!inMonth) cls += ' ww-neighbor'
            if (isSel)     cls += ' ww-selected'
            if (isPast)    cls += ' ww-past'

            return (
              <div
                key={day.toISOString()}
                className={cls}
                onClick={() => inMonth && !isPast && onSelect(day)}
              >
                {format(day, 'd')}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
